import { Button, TextField } from "@material-ui/core";
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import * as React from "react";
import { ConnectedProps, connect } from 'react-redux';
import { IState } from '../../redux/store';
import { IPlantDetailsUpdateDTO } from '../../repository/jago/domainsAPI';
import ReduxLanguage from "../ReduxLanguage";

const styles = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    padding: 20,
    flex: 1,
  },
  formTitle: {
    fontWeight: 'bold',
    marginBottom: 20,
  },
  inputTitle: {
    marginTop: 20,
    marginBottom: 8,
    fontSize: 18,
    fontWeight: 'bold',
  },
});

export interface IEditPlantSOCDetailsFormState {
  formData: IPlantDetailsUpdateDTO;
}

export interface IEditPlantSOCDetailsFormProps extends WithStyles<typeof styles> {
  onSubmit: (data: IPlantDetailsUpdateDTO) => void;
  initialData?: IPlantDetailsUpdateDTO;
}

type IReduxProps = ConnectedProps<typeof connector>;

export type ComponentProps = IEditPlantSOCDetailsFormProps & IReduxProps;

class EditPlantSOCDetailsForm extends React.Component<ComponentProps, IEditPlantSOCDetailsFormState> {

  constructor(props: ComponentProps) {
    super(props);
    this.state = {
      formData: props.initialData ? {
        zenDeskId: props.initialData.zenDeskId || '',
        lockbaseId: props.initialData.lockbaseId || '',
        license1ris: props.initialData.license1ris || '',
      } : {
        zenDeskId: '',
        lockbaseId: '',
        license1ris: '',
      },
    };
  }

  onChangeValue = (field: keyof IPlantDetailsUpdateDTO, value: string) => {
    const { formData } = this.state;
    this.setState({
      formData: { ...formData, [field]: value }
    });
  }

  onSubmitForm = () => {
    const { formData } = this.state;
    const { onSubmit } = this.props;
    onSubmit(formData);
  }

  public render() {
    const { classes } = this.props;
    const { formData } = this.state;

    return (
      <div className={classes.container}>
        <h2 className={classes.formTitle}><ReduxLanguage languageKey={'domains.editPlantDetails'} /></h2>
        <div style={{ flex: 0, marginRight: 10 }}>
          <TextField
            id="zenDeskId"
            label={<ReduxLanguage languageKey={'domains.zenDeskId'} />}
            variant="outlined"
            fullWidth
            value={formData.zenDeskId}
            style={{ marginTop: 20 }}
            onChange={e => this.onChangeValue('zenDeskId', e.target.value)}
          />
          <TextField
            id="lockbaseId"
            label={<ReduxLanguage languageKey={'domains.lockbaseId'} />}
            variant="outlined"
            fullWidth
            value={formData.lockbaseId}
            style={{ marginTop: 20 }}
            onChange={e => this.onChangeValue('lockbaseId', e.target.value)}
          />
          <TextField
            id="license1ris"
            label={<ReduxLanguage languageKey={'domains.license1ris'} />}
            variant="outlined"
            fullWidth
            value={formData.license1ris}
            style={{ marginTop: 20 }}
            onChange={e => this.onChangeValue('license1ris', e.target.value)}
          />
        </div>
        <div style={{ position: 'sticky', bottom: '0', paddingTop: '20px', backgroundColor: 'white', marginLeft: '-5px', marginRight: '-5px', zIndex: 1 }}>
          <Button
            variant="contained"
            style={{ width: '100%', backgroundColor: '#5AC0B1', color: 'white', borderRadius: 0, height: 50, fontWeight: 'bold' }}
            onClick={() => this.onSubmitForm()}
          >
            <ReduxLanguage languageKey="forms.save" />
          </Button>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: IState) {
  return {
    language: state.settings.language,
  };
}

const connector = connect(mapStateToProps);

export default connector(withStyles(styles)(EditPlantSOCDetailsForm));
